export default __webpack_public_path__ + "static/media/jumber2056.b12debea.png";